module.exports = __webpack_public_path__ + "img/egg_stars_happy.16635a08.svg";